import React from "react";
import {
  alpha,
  ThemeProvider,
  withStyles,
  makeStyles,
  createTheme,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import "../styles/inputField.scss";

const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "green",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "green",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "red",
      },
      "&:hover fieldset": {
        borderColor: "yellow",
      },
      "&.Mui-focused fieldset": {
        borderColor: "green",
      },
    },
  },
})(TextField);

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export default function InputField({
  value,
  onChangeValue,
  label,
  isPassword,
  icon,
}) {
  const classes = useStyles();

  return (
    <div className="quiz-text-field">
      {icon && <img src={icon} />}
      <span className="placeholder">+880</span>

      <TextField
        label={label}
        type={"phone"}
        id="filled-size-normal"
        value={value}
        onChange={onChangeValue}
        variant="filled"
      />
    </div>
  );
}
